export class NotificationModel {
  title: string;
  body: string;
  read: boolean;


  constructor(title: string, body: string, read: boolean) {
    this.title = title;
    this.body = body;
    this.read = read;
  }
}
